import { inject, Injectable } from '@angular/core';
import { IUseCase } from '@core/base/use-case.interface';
import { DocumentTypeEnum } from '@core/enums/document/document-type.enum';
import { IPolicyAcceptedResponseDto } from '@core/interfaces/api/policies/policy-accepted-response-dto.interface';
import { FtsAccessManagementApiService } from '@core/services/api/access-management.api.service';
import { PolicyService } from '@core/services/policy.service';
import { Observable, tap } from 'rxjs';

@Injectable()
export class AcceptPolicyUseCaseService
  implements IUseCase<DocumentTypeEnum, IPolicyAcceptedResponseDto>
{
  private readonly ftsAccessManagementService = inject(FtsAccessManagementApiService);
  private readonly policyService = inject(PolicyService);

  execute(params: DocumentTypeEnum): Observable<IPolicyAcceptedResponseDto> {
    return this.ftsAccessManagementService.acceptPolicy(params).pipe(
      tap(() => {
        this.policyService.setTermsAcceptance();
      })
    );
  }
}
